import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { switchMap, tap, map } from 'rxjs/operators';
import { SortColumn, SortDirection } from '../_directives/sortable.directive';
import { State } from '../_models/State';
import { DynamicCss, Settings } from '../_models/Settings';


interface SearchGeneralsettingsResult {
  data: Settings[];
  total: number;
}
const compare = (v1: string, v2: string) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

@Injectable({
  providedIn: 'root'
})

export class SettingService {

  constructor(private http: HttpClient) {
  }

  private _loading$ = new BehaviorSubject<boolean>(true);
  private _search$ = new Subject<void>();
  private _allData$ = new BehaviorSubject<Settings[]>([]);
  private _data$ = new BehaviorSubject<Settings[]>([]);
  private _total$ = new BehaviorSubject<number>(0);
  public settings: Settings[];
  private _state: State = {
    page: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: '',
    sortDirection: ''
  };

  get total$() { return this._total$.asObservable(); }
  get loading$() { return this._loading$.asObservable(); }
  get page() { return this._state.page; }
  get pageSize() { return this._state.pageSize; }
  get searchTerm() { return this._state.searchTerm; }

  set page(page: number) { this._set({ page }); }
  set pageSize(pageSize: number) { this._set({ pageSize }); }
  set searchTerm(searchTerm: any) { this._set({ searchTerm }); }
  set sortColumn(sortColumn: SortColumn) { this._set({ sortColumn }); }
  set sortDirection(sortDirection: SortDirection) { this._set({ sortDirection }); }

  get data$() {
    return this._data$.asObservable();
  }
  get allData$() {
    return this._allData$.asObservable();
  }
  

  getById(id) {
    return this.http.get<Settings[]>(`api/settings/get/${id}`);
  }

  getCssById(id) {
    return this.http.get<DynamicCss[]>(`api/settings/getcss/${id}`);
  }
  getThemeByName(id) {
    return this.http.get<DynamicCss[]>(`api/settings/getcss/${id}`);
  }
 
  private _set(patch: Partial<State>) {
    Object.assign(this._state, patch);
    this._search$.next();
  }

  
  clear() {
    // clear by calling subject.next() without parameters
    this._search$.next();
    this._data$.next(null);
    this._allData$.next(null);
    this._total$.next(null);
    this._loading$.next(null);
    this._state = {
      page: 1,
      pageSize: 10,
      searchTerm: '',
      sortColumn: '',
      sortDirection: ''
    };
  }
  update(updateData) {
    return this.http.post(`api/settings/update`, updateData)
      .pipe(map(res => {
        console.log(res);
        return res;
      }));
  }
  updateCss(updateData) {
    return this.http.post(`api/settings/updateCss`, updateData)
      .pipe(map(res => {
        console.log(res);
        return res;
      }));
  }
}
